enum AxisLabel {
  X = 'X',
  Y = 'Y',
}

export const labelLookup: Record<AxisLabel, string> = {
  [AxisLabel.X]: 'X axis',
  [AxisLabel.Y]: 'Y Axis',
}
